module.exports = __webpack_public_path__ + "img/code-commit.23bb8459.svg";